import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const Messages = () => (
  <Card sx={{ mb: 2 }}>
    <CardContent>
      <Typography variant="h6">Important Messages</Typography>
      <Typography>Check your inbox for recent updates.</Typography>
    </CardContent>
  </Card>
);

export default Messages;